var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64, _circle65, _circle66, _circle67, _circle68, _circle69, _circle70, _circle71, _circle72, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeftGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 435,
    height: 222,
    viewBox: "0 0 435 222",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 174,
    cy: 144,
    r: 3,
    fill: "#14B6A7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 144,
    r: 3,
    fill: "#14B6A7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 204,
    cy: 144,
    r: 3,
    fill: "#14B6A7"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 219,
    cy: 144,
    r: 3,
    fill: "#14B6A7"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 234,
    cy: 144,
    r: 3,
    fill: "#14B6A7"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 144,
    r: 3,
    fill: "#14B6A7"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 174,
    cy: 159,
    r: 3,
    fill: "#14B6A7"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 159,
    r: 3,
    fill: "#14B6A7"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 204,
    cy: 159,
    r: 3,
    fill: "#14B6A7"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 219,
    cy: 159,
    r: 3,
    fill: "#14B6A7"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 234,
    cy: 159,
    r: 3,
    fill: "#14B6A7"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 159,
    r: 3,
    fill: "#14B6A7"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 174,
    cy: 174,
    r: 3,
    fill: "#14B6A7"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 174,
    r: 3,
    fill: "#14B6A7"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 204,
    cy: 174,
    r: 3,
    fill: "#14B6A7"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 219,
    cy: 174,
    r: 3,
    fill: "#14B6A7"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 234,
    cy: 174,
    r: 3,
    fill: "#14B6A7"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 174,
    r: 3,
    fill: "#14B6A7"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 174,
    cy: 189,
    r: 3,
    fill: "#14B6A7"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 189,
    r: 3,
    fill: "#14B6A7"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 204,
    cy: 189,
    r: 3,
    fill: "#14B6A7"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 219,
    cy: 189,
    r: 3,
    fill: "#14B6A7"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 234,
    cy: 189,
    r: 3,
    fill: "#14B6A7"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 189,
    r: 3,
    fill: "#14B6A7"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 174,
    cy: 204,
    r: 3,
    fill: "#14B6A7"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 204,
    r: 3,
    fill: "#14B6A7"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 204,
    cy: 204,
    r: 3,
    fill: "#14B6A7"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 219,
    cy: 204,
    r: 3,
    fill: "#14B6A7"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 234,
    cy: 204,
    r: 3,
    fill: "#14B6A7"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 204,
    r: 3,
    fill: "#14B6A7"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 174,
    cy: 219,
    r: 3,
    fill: "#14B6A7"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 219,
    r: 3,
    fill: "#14B6A7"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 204,
    cy: 219,
    r: 3,
    fill: "#14B6A7"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 219,
    cy: 219,
    r: 3,
    fill: "#14B6A7"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 234,
    cy: 219,
    r: 3,
    fill: "#14B6A7"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 219,
    r: 3,
    fill: "#14B6A7"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 13,
    r: 3,
    fill: "#14B6A7"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 13,
    r: 3,
    fill: "#14B6A7"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 13,
    r: 3,
    fill: "#14B6A7"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 13,
    r: 3,
    fill: "#14B6A7"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 13,
    r: 3,
    fill: "#14B6A7"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 13,
    r: 3,
    fill: "#14B6A7"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 28,
    r: 3,
    fill: "#14B6A7"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 28,
    r: 3,
    fill: "#14B6A7"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 28,
    r: 3,
    fill: "#14B6A7"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 28,
    r: 3,
    fill: "#14B6A7"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 28,
    r: 3,
    fill: "#14B6A7"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 28,
    r: 3,
    fill: "#14B6A7"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 43,
    r: 3,
    fill: "#14B6A7"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 43,
    r: 3,
    fill: "#14B6A7"
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 43,
    r: 3,
    fill: "#14B6A7"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 43,
    r: 3,
    fill: "#14B6A7"
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 43,
    r: 3,
    fill: "#14B6A7"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 43,
    r: 3,
    fill: "#14B6A7"
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 58,
    r: 3,
    fill: "#14B6A7"
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 58,
    r: 3,
    fill: "#14B6A7"
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 58,
    r: 3,
    fill: "#14B6A7"
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 58,
    r: 3,
    fill: "#14B6A7"
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 58,
    r: 3,
    fill: "#14B6A7"
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 58,
    r: 3,
    fill: "#14B6A7"
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 73,
    r: 3,
    fill: "#14B6A7"
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 73,
    r: 3,
    fill: "#14B6A7"
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 73,
    r: 3,
    fill: "#14B6A7"
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 73,
    r: 3,
    fill: "#14B6A7"
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 73,
    r: 3,
    fill: "#14B6A7"
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 73,
    r: 3,
    fill: "#14B6A7"
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 88,
    r: 3,
    fill: "#14B6A7"
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 88,
    r: 3,
    fill: "#14B6A7"
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 88,
    r: 3,
    fill: "#14B6A7"
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 88,
    r: 3,
    fill: "#14B6A7"
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 88,
    r: 3,
    fill: "#14B6A7"
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 88,
    r: 3,
    fill: "#14B6A7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78 74C78 33.1309 111.131 0 152 0H435V148H152C111.131 148 78 114.869 78 74Z",
    fill: "#14B6A7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftGroup);
export default __webpack_public_path__ + "static/media/left-group.a9d317443abe6dc4a5223f156b79a74c.svg";
export { ForwardRef as ReactComponent };